<template>
  <div class="">
    <div>
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div
          class="flex flex-col md:flex-row md:justify-between md:items-center gap-[10px] md:gap-0 mb-2"
        >
          <div class="flex flex-col gap-[16px]">
            <button
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB] max-w-max"
            >
              All campaigns
            </button>
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              Manage All campaigns here
            </p>
          </div>
          <div class="flex gap-[10px] items-center">
            <button
              @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              @click="viewAdd"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full"
              v-if="hasPermission('Customer_Create')"
            >
              <i class="feather icon-plus"></i> &nbsp;New Campaign
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table dataTable m-0 p-0 text-nowrap min-h-[150px]">
            <thead class="bg-white">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Name
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Status
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Parent
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Created
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                ></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we load the list
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="c in campaigns" :key="c.id" v-else>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ c.name }}
                </td>
                <td>
                  <span
                    class="flex items-center gap-[4px] max-w-max w-full"
                    :class="[
                      'badge',
                      { 'badge-success': c.active, 'badge-danger': !c.active },
                    ]"
                  >
                    <span
                      class="w-[10px] h-[10px] rounded-[1px]"
                      :style="{
                        backgroundColor: c.active ? '#16a249' : '#EF5253',
                      }"
                    ></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">{{
                      c.active ? "Active" : "Inactive"
                    }}</span>
                  </span>
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ c.parent ? c.parent.name : "N/A" }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatDate(c.created) }}
                </td>
                <td>
                  <div class="dropdown">
                    <div class="dropdown">
                      <button
                        class="btn-no-border"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span
                          class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                        >
                          ...
                        </span>
                      </button>
                      <ul
                        class="dropdown-menu shadow-none"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li
                          @click.prevent="viewRemove(c)"
                          v-if="hasPermission('Campaign_Delete')"
                          :class="[
                            'text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]',
                            hasPermission('Campaign_View_Members') ||
                            (!c.active && hasPermission('Campaign_Delete'))
                              ? 'border-b border-[#e5e7eb]'
                              : '',
                          ]"
                        >
                          {{ c.active ? "Disable" : "Enable" }}
                        </li>
                        <li
                          @click.prevent="viewMembers(c)"
                          v-if="hasPermission('Campaign_View_Members')"
                          :class="[
                            'text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]',
                            !c.active && hasPermission('Campaign_Delete')
                              ? 'border-b border-[#e5e7eb]'
                              : '',
                          ]"
                        >
                          View {{ c.memberCount }} member{{
                            c.memberCount != 1 ? "s" : ""
                          }}
                        </li>
                        <li
                          v-if="!c.active && hasPermission('Campaign_Delete')"
                          style="color: red"
                          @click.prevent="confirmDelete(c.id)"
                          class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                        >
                          Delete Campaign
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!campaigns.length && !loading">
                <td colspan="5">
                  <div class="text-center" style="padding-top: 25px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-bullhorn"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 50px">
                    You don't have any campaigns.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-delete" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header modal-header-colored  flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              {{ deletingCampaign.active ? "disable" : "enable" }} Confirmation
            </h4>
            <button
              class="text-2xl text-[#353535] border-solid border-[#353535] border-[1.5px] rounded-full px-[4px]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <p class="text-[#96a0b5] text[14px] font-normal leading-[20px]">
              Are you sure you want to
              {{ deletingCampaign.active ? "disable" : "enable" }} this
              campaign: <strong>{{ deletingCampaign.name }}</strong
              >?
            </p>
          </div>
          <div class="mt-[16px] flex items-center gap-[8px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="py-[16px] px-[16px] sm:px-[24px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              :class="{
                'bg-[#DC2828] border-[#DC2828] text-[16px]':
                  deletingCampaign.active,
                'bg-[#2463eb] border-[#2463eb] text-[14px] md:text-[16px]': !deletingCampaign.active,
              }"
              type="button"
              :disabled="isBusyModal"
              @click.prevent="updateStatus"
            >
              {{ isBusyModal ? "Loading..." : "Yes, Proceed" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All Campaigns</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getCampaigns"
            >
              {{ isBusy ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteCampaign"
      :isBusy="isBusyModal"
      text="campaign"
    />
    <GeneralDeleteMessage
      message="You cannot delete this campaign because there is currently active. Disable the campaign first and then retry."
    />
    <viewMember
      :closeModal="closeModal"
      v-if="isModalVisible"
      :campaignId="campaignId"
    />
    <NewCampaign @new-create="onNewCreate" />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import Select2 from "@/components/Select2";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import SystemPermissions from "@/permissions";
import Pagination from "../components/Pagination.vue";
import viewMember from "../components/Campaign/viewMember.vue";
import NewCampaign from "../components/Campaign/NewCampaign.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "campaigns",
  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    viewMember,
    NewCampaign,
  },
  created() {
    if (!this.hasPermission("Campaign_View")) {
      this.$router.push("/restricted");
    }
    this.getCampaigns();
  },
  data() {
    return {
      filter: {
        status: "0",
      },
      deletingCampaign: {},
      DeleteId: "",
      isBusy: false,
      isBusyModal: false,
      campaigns: [],
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      loading: false,
      isModalVisible: false,
      campaignId: "",
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    reset() {
      this.filter = {
        status: "0",
      };
    },
    viewAdd() {
      $("#mod-campaign-add").modal("show");
    },
    async onNewCreate() {
      await this.getCampaigns();
    },
    viewMembers(c) {
      this.campaignId = c.id;
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
      this.getCampaigns();
    },
    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteCampaign() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(`/Campaigns/${this.DeleteId}`);
        if (res.ok) {
          this.$toast.success("Campaign deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getCampaigns();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    viewFilter() {
      this.page = 1;
      $("#mod-filter").modal("show");
    },
    viewRemove(c) {
      this.deletingCampaign = c;
      $("#mod-delete").modal("show");
    },
    details(id) {
      this.$router.push("/campaigns/" + id);
    },
    updateStatus() {
      this.isBusyModal = true;
      let data = {
        id: this.deletingCampaign.id,
        active: !this.deletingCampaign.active,
      };

      $("#mod-delete").modal("hide");

      this.$http
        .put("/Campaigns/updateStatus/" + data.id, data)
        .then(function(res) {
          this.isBusyModal = false;
          this.getCampaigns();
        })
        .catch(function() {
          this.isBusyModal = false;
        });
    },
    async getCampaigns() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Campaigns/getList?page=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.campaigns = res.body.data;
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.isBusy = false;
          this.loading = false;
        });

      $("#mod-filter").modal("hide");

      this.isBusy = false;
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    prev() {
      this.page -= 1;
      this.getCampaigns();
    },
    next() {
      this.page += 1;
      this.getCampaigns();
    },

    gotoPage(page) {
      this.page = page;
      this.getCampaigns();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.page = 0;
      this.getCampaigns();
    },
  },
};
</script>
